module.exports = __webpack_public_path__ + "assets/img/forest-1.11fdea7b.png";